import { render, staticRenderFns } from "./ImsProfitLossCommissionsList.vue?vue&type=template&id=5286ab00&"
import script from "./ImsProfitLossCommissionsList.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossCommissionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports